import { rgbToArray, stringToIntArray } from "./utils";
import { LAYER_WMS_TYPES } from "./pages/map/base_maps/MapBaseLeaflet";

const USER_GBN = window.USER_GBN;
//const GEOSERVER_URL = window.GEOSERVER_URL || "https://spectrummap.kr/geoserver/";
const GEOSERVER_URL = window.GEOSERVER_URL || "http://100.100.47.15:8080/geoserver/";
const DEBUG = process.env.NODE_ENV === "development";
const API_HOST = window.API_HOST || process.env.REACT_APP_API_HOST || "";

const GOOGLE_LANGUAGE = window.GOOGLE_LANGUAGE || "ko";
const GOOGLE_REGION = window.GOOGLE_REGION || "KR";
const GOOGLE_MAPS_API_KEY = window.GOOGLE_MAPS_APIKEY || process.env.REACT_APP_GOOGLE_MAPS_APIKEY;
const GOOGLE_MAPS_VERSION = window.GOOGLE_MAPS_VERSION || process.env.REACT_APP_GOOGLE_MAPS_VERSION || "weekly"; // 3.39, quarterly
const GOOGLE_MAPS_REGION = window.GOOGLE_MAPS_REGION || process.env.REACT_APP_GOOGLE_MAPS_REGION || "KR";
// const GOOGLE_MAPS_API_URL = `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_MAPS_API_KEY}&libraries=visualization&region=${GOOGLE_REGION}`;

const KAKAO_MAPS_API_KEY = window.KAKAO_MAPS_APIKEY || process.env.REACT_APP_KAKAO_MAPS_APIKEY;
const KAKAO_MAPS_API_URL = `//dapi.kakao.com/v2/maps/sdk.js?appkey=${KAKAO_MAPS_API_KEY}&autoload=false&libraries=services`;

const MAPBOX_APIKEY = window.MAPBOX_ACCESS_TOKEN || process.env.REACT_APP_MAPBOX_ACCESS_TOKEN;
const MAPBOX_STYLE = window.MAPBOX_STYLE || "mapbox://styles/adrina-lee/ck17c6rf04o5o1cpm1fcptnd2";

const VWORLD_APIKEY = window.VWORLD_APIKEY || process.env.REACT_APP_VWORLD_APIKEY;

const MAP_VENDOR = window.MAP_VENDOR || "vworld"; // "vworld" or "google"
const INITIAL_MAP_TYPE = `leaflet-${MAP_VENDOR}-base`;

const WELL_KNOWN_POSITION = {
  서울특별시: { latitude: 37.5326, longitude: 127.024612 },
  코엑스: { latitude: 37.496256, longitude: 127.062191 },
  광화문: { latitude: 37.5759369, longitude: 126.9593062 },
  대전둔산동: { latitude: 36.35111, longitude: 127.385 },
  세종특별자치시: { latitude: 36.4806503, longitude: 127.2855187 },
  경기도: { latitude: 37.6166385, longitude: 127.2076916 },
  fiveG: { latitude: 36.4323321, longitude: 129.3530273 },
  지리산: { latitude: 35.331142718500104, longitude: 127.63935895899999 },
  남산공원: { latitude: 37.5524979951415, longitude: 126.989316855952 },
  대한민국: { latitude: 35.951329861522666, longitude: 127.93579101562501 },
};

const SPECTRUM_BGN_FRQ_HZ = parseInt(window.SPECTRUM_BGN_FRQ_HZ || 1500);
const SPECTRUM_END_FRQ_HZ = parseInt(window.SPECTRUM_END_FRQ_HZ || 2100);
const SPECTRUM_FRQ_HZ = parseInt(window.SPECTRUM_FRQ_HZ || 1000000); // MHz
const SPECTRUM_SIDO_CHECK_LIST = []; // 11(서울), 26(부산)
const SPECTRUM_UCODE_CHECK_LIST = []; // C5(이동통신), C6(공공/민간)
const SPECTRUM_USAGE_CHECK_LIST = [];

const INITIAL_VIEW_STATE = {
  ...WELL_KNOWN_POSITION.대전둔산동,
  // latitude: ,
  // longitude: ,
  zoom: 7,
  pitch: 0,
  bearing: 0,
  minZoom: 6,
  maxZoom: 18,
};

const INITIAL_GEOJSON_POLYGON_LAYER_PROPS = {
  stroked: true,
  filled: true,
  getFillColor: (feature) => [100, 100, 255, 150],
  getLevelFillColor: undefined, // Custom Props
  getLevelLineColor: undefined, // Custom Props
  lineWidthMinPixels: 2,
};

const INITIAL_GEOJSON_POINT_LAYER_PROPS = {
  opacity: 0.8,
  stroked: true,
  filled: true,
  getRadius: 4,
  pointRadiusMinPixels: 2,
  lineWidthUnits: "pixels",
  getFillColor: rgbToArray("#FF0000"),
};

const INITIAL_POINT_LAYER_PROPS = {
  // 같은 위도/경도 포인트의 Marker에 대해, 가장 큰 iconCode의 Marker를 BIG으로 판단하여 Marker를 그리고,
  // 그 외 Marker는 그리지 않습니다. (MapBaseLeaflet.js에서의 구현)
  isBigIconCode: function (pointA, pointB) {
    if (!this.getIconCode) return true;
    const codeA = stringToIntArray(this.getIconCode(pointA));
    const codeB = stringToIntArray(this.getIconCode(pointB));
    return codeA < codeB;
  },
  getIconWidth: (feature, zoom) => {
    let iconWidth = 30;
    if (zoom < 14) {
      iconWidth -= (iconWidth * (15 - Math.max(7, zoom))) / 10;
      return Math.min(25.2, iconWidth);
    } else {
      iconWidth -= (iconWidth * (15 - Math.max(7, zoom))) / 5;
      return Math.min(30, iconWidth);
    }
    // return iconWidth;
  },
};

const INITIAL_LAYER_WMS_TYPES = [LAYER_WMS_TYPES.KCA_group_uq];

const JSON_SIGUNGU = [
  {
    SIG_KOR_NM: "강남구",
    SIG_CD: "11680",
    LON: 127.062985328438,
    LAT: 37.496643795773,
    LX: 127.00857826409,
    LY: 37.4561161746471,
    RX: 127.12420693151,
    RY: 37.5358413104032,
    SID_CD: "11",
  },
  {
    SIG_KOR_NM: "강동구",
    SIG_CD: "11740",
    LON: 127.147011885527,
    LAT: 37.550450263974,
    LX: 127.109142759849,
    LY: 37.5168353417035,
    RX: 127.183794925064,
    RY: 37.5812007154756,
    SID_CD: "11",
  },
  {
    SIG_KOR_NM: "강북구",
    SIG_CD: "11305",
    LON: 127.01118900353,
    LAT: 37.6434738703691,
    LX: 126.979658110736,
    LY: 37.6089737150985,
    RX: 127.049736656203,
    RY: 37.6850888206292,
    SID_CD: "11",
  },
  {
    SIG_KOR_NM: "강서구",
    SIG_CD: "11500",
    LON: 126.822807155217,
    LAT: 37.5612353821152,
    LX: 126.764483958188,
    LY: 37.5264841728633,
    RX: 126.880791938336,
    RY: 37.6050327500841,
    SID_CD: "11",
  },
  {
    SIG_KOR_NM: "관악구",
    SIG_CD: "11620",
    LON: 126.945337234548,
    LAT: 37.4673756698072,
    LX: 126.898943795468,
    LY: 37.4357123167234,
    RX: 126.988635782252,
    RY: 37.4950710107711,
    SID_CD: "11",
  },
  {
    SIG_KOR_NM: "광진구",
    SIG_CD: "11215",
    LON: 127.085743560354,
    LAT: 37.5467060980824,
    LX: 127.056219054413,
    LY: 37.5225150993122,
    RX: 127.115252580961,
    RY: 37.5737634901177,
    SID_CD: "11",
  },
  {
    SIG_KOR_NM: "구로구",
    SIG_CD: "11530",
    LON: 126.856300747635,
    LAT: 37.4944054474535,
    LX: 126.813012397936,
    LY: 37.4731877872774,
    RX: 126.903198618286,
    RY: 37.5177752066585,
    SID_CD: "11",
  },
  {
    SIG_KOR_NM: "금천구",
    SIG_CD: "11545",
    LON: 126.900820269691,
    LAT: 37.4605675312272,
    LX: 126.87176262264,
    LY: 37.4335177904599,
    RX: 126.928506462282,
    RY: 37.486662123788,
    SID_CD: "11",
  },
  {
    SIG_KOR_NM: "노원구",
    SIG_CD: "11350",
    LON: 127.075035909445,
    LAT: 37.6525106719745,
    LX: 127.041658152525,
    LY: 37.6142672911594,
    RX: 127.112548888069,
    RY: 37.6961374676419,
    SID_CD: "11",
  },
  {
    SIG_KOR_NM: "도봉구",
    SIG_CD: "11320",
    LON: 127.032368828571,
    LAT: 37.6691020619231,
    LX: 127.007620764449,
    LY: 37.6304142702129,
    RX: 127.05587292378,
    RY: 37.7014552792184,
    SID_CD: "11",
  },
  {
    SIG_KOR_NM: "동대문구",
    SIG_CD: "11230",
    LON: 127.054848157625,
    LAT: 37.5819565487273,
    LX: 127.023138747958,
    LY: 37.5599626001343,
    RX: 127.07822585293,
    RY: 37.6076286310665,
    SID_CD: "11",
  },
  {
    SIG_KOR_NM: "동작구",
    SIG_CD: "11590",
    LON: 126.951641550686,
    LAT: 37.4988768600309,
    LX: 126.903198618298,
    LY: 37.4753765524091,
    RX: 126.98538509944,
    RY: 37.5176209937903,
    SID_CD: "11",
  },
  {
    SIG_KOR_NM: "마포구",
    SIG_CD: "11440",
    LON: 126.908108618168,
    LAT: 37.5594178591138,
    LX: 126.853628583746,
    LY: 37.5337808510855,
    RX: 126.963898333275,
    RY: 37.5907926405595,
    SID_CD: "11",
  },
  {
    SIG_KOR_NM: "서대문구",
    SIG_CD: "11410",
    LON: 126.93904451854,
    LAT: 37.5777004352595,
    LX: 126.901829082229,
    LY: 37.5534510488295,
    RX: 126.969464124434,
    RY: 37.6106169018518,
    SID_CD: "11",
  },
  {
    SIG_KOR_NM: "서초구",
    SIG_CD: "11650",
    LON: 127.031220478364,
    LAT: 37.4732953451154,
    LX: 126.979834915457,
    LY: 37.4282974777967,
    RX: 127.095752953353,
    RY: 37.5255950357638,
    SID_CD: "11",
  },
  {
    SIG_KOR_NM: "성동구",
    SIG_CD: "11200",
    LON: 127.041058574633,
    LAT: 37.5510296912891,
    LX: 127.008153294764,
    LY: 37.5283238557128,
    RX: 127.073735263961,
    RY: 37.5730208303792,
    SID_CD: "11",
  },
  {
    SIG_KOR_NM: "성북구",
    SIG_CD: "11290",
    LON: 127.017579607684,
    LAT: 37.6057018884361,
    LX: 126.974670905142,
    LY: 37.5775180878907,
    RX: 127.071732223476,
    RY: 37.6364568876754,
    SID_CD: "11",
  },
  {
    SIG_KOR_NM: "송파구",
    SIG_CD: "11710",
    LON: 127.115337179838,
    LAT: 37.5056315416352,
    LX: 127.067501152438,
    LY: 37.4665208839273,
    RX: 127.161431135221,
    RY: 37.5431713116096,
    SID_CD: "11",
  },
  {
    SIG_KOR_NM: "양천구",
    SIG_CD: "11470",
    LON: 126.855477754469,
    LAT: 37.5247894306037,
    LX: 126.821590568592,
    LY: 37.5028694252568,
    RX: 126.890684284648,
    RY: 37.5512400894123,
    SID_CD: "11",
  },
  {
    SIG_KOR_NM: "영등포구",
    SIG_CD: "11560",
    LON: 126.910246063015,
    LAT: 37.52239474907,
    LX: 126.877928611056,
    LY: 37.4850015500803,
    RX: 126.949886838711,
    RY: 37.5562694260742,
    SID_CD: "11",
  },
  {
    SIG_KOR_NM: "용산구",
    SIG_CD: "11170",
    LON: 126.979907043368,
    LAT: 37.5313849726223,
    LX: 126.944585187597,
    LY: 37.5065316428905,
    RX: 127.017530349301,
    RY: 37.5556625709692,
    SID_CD: "11",
  },
  {
    SIG_KOR_NM: "은평구",
    SIG_CD: "11380",
    LON: 126.927022918178,
    LAT: 37.6192113504799,
    LX: 126.882030895939,
    LY: 37.5760049161205,
    RX: 126.963328787258,
    RY: 37.6592153859404,
    SID_CD: "11",
  },
  {
    SIG_KOR_NM: "종로구",
    SIG_CD: "11110",
    LON: 126.977321336243,
    LAT: 37.5949172718044,
    LX: 126.948898563208,
    LY: 37.5658199517111,
    RX: 127.023365324364,
    RY: 37.6323747675695,
    SID_CD: "11",
  },
  {
    SIG_KOR_NM: "중구",
    SIG_CD: "11140",
    LON: 126.995968200484,
    LAT: 37.5601435654536,
    LX: 126.961549699549,
    LY: 37.543857396673,
    RX: 127.026797023406,
    RY: 37.5720223476478,
    SID_CD: "11",
  },
  {
    SIG_KOR_NM: "중랑구",
    SIG_CD: "11260",
    LON: 127.092880357531,
    LAT: 37.5978026005203,
    LX: 127.069423591766,
    LY: 37.5696939732534,
    RX: 127.118477206512,
    RY: 37.6210546546973,
    SID_CD: "11",
  },
  {
    SIG_KOR_NM: "강서구",
    SIG_CD: "26440",
    LON: 128.892399609197,
    LAT: 35.1383463825802,
    LX: 128.761717879344,
    LY: 34.989092766539,
    RX: 128.998224295757,
    RY: 35.2360805121591,
    SID_CD: "26",
  },
  {
    SIG_KOR_NM: "금정구",
    SIG_CD: "26410",
    LON: 129.09153037406,
    LAT: 35.2588907606267,
    LX: 129.036564268744,
    LY: 35.2095407796563,
    RX: 129.144605942405,
    RY: 35.3065840441719,
    SID_CD: "26",
  },
  {
    SIG_KOR_NM: "기장군",
    SIG_CD: "26710",
    LON: 129.200791490203,
    LAT: 35.2980025596026,
    LX: 129.108561975638,
    LY: 35.181619863681,
    RX: 129.304139586198,
    RY: 35.3890374477077,
    SID_CD: "26",
  },
  {
    SIG_KOR_NM: "남구",
    SIG_CD: "26290",
    LON: 129.094006226249,
    LAT: 35.1261368706486,
    LX: 129.063001069824,
    LY: 35.0909075471021,
    RX: 129.128720750536,
    RY: 35.1613184639494,
    SID_CD: "26",
  },
  {
    SIG_KOR_NM: "동구",
    SIG_CD: "26170",
    LON: 129.044585507045,
    LAT: 35.129186293386,
    LX: 129.024308614959,
    LY: 35.1086637795962,
    RX: 129.06621855845,
    RY: 35.1461737220697,
    SID_CD: "26",
  },
  {
    SIG_KOR_NM: "동래구",
    SIG_CD: "26260",
    LON: 129.079219832779,
    LAT: 35.2062124842575,
    LX: 129.044128759728,
    LY: 35.1833258663921,
    RX: 129.116370308223,
    RY: 35.2262731812843,
    SID_CD: "26",
  },
  {
    SIG_KOR_NM: "부산진구",
    SIG_CD: "26230",
    LON: 129.043060141429,
    LAT: 35.1652441135054,
    LX: 129.010503066969,
    LY: 35.1355075208878,
    RX: 129.082831855566,
    RY: 35.2000788505982,
    SID_CD: "26",
  },
  {
    SIG_KOR_NM: "북구",
    SIG_CD: "26320",
    LON: 129.02343975826,
    LAT: 35.2292295435869,
    LX: 128.986962951025,
    LY: 35.1874751365159,
    RX: 129.061767271569,
    RY: 35.2768946067147,
    SID_CD: "26",
  },
  {
    SIG_KOR_NM: "사상구",
    SIG_CD: "26530",
    LON: 128.98659216063,
    LAT: 35.1580303164713,
    LX: 128.95744471443,
    LY: 35.1169247989377,
    RX: 129.021085009415,
    RY: 35.2014551184426,
    SID_CD: "26",
  },
  {
    SIG_KOR_NM: "사하구",
    SIG_CD: "26380",
    LON: 128.974348833747,
    LAT: 35.0893484138584,
    LX: 128.933977856805,
    LY: 34.889676139809,
    RX: 129.014364927553,
    RY: 35.1368451724077,
    SID_CD: "26",
  },
  {
    SIG_KOR_NM: "서구",
    SIG_CD: "26140",
    LON: 129.01495381007,
    LAT: 35.1038366606296,
    LX: 128.996015239176,
    LY: 35.0479761263772,
    RX: 129.028096660515,
    RY: 35.1409886898872,
    SID_CD: "26",
  },
  {
    SIG_KOR_NM: "수영구",
    SIG_CD: "26500",
    LON: 129.111162666025,
    LAT: 35.1613314749572,
    LX: 129.091552318591,
    LY: 35.1357516499775,
    RX: 129.135034983163,
    RY: 35.1865003817838,
    SID_CD: "26",
  },
  {
    SIG_KOR_NM: "연제구",
    SIG_CD: "26470",
    LON: 129.082935107449,
    LAT: 35.1824180109505,
    LX: 129.047321130864,
    LY: 35.1581737633075,
    RX: 129.115176988668,
    RY: 35.1995343906655,
    SID_CD: "26",
  },
  {
    SIG_KOR_NM: "영도구",
    SIG_CD: "26200",
    LON: 129.06475004264,
    LAT: 35.0787193049657,
    LX: 129.030992013349,
    LY: 35.0366990693139,
    RX: 129.105242530518,
    RY: 35.1036483724252,
    SID_CD: "26",
  },
  {
    SIG_KOR_NM: "중구",
    SIG_CD: "26110",
    LON: 129.031540146718,
    LAT: 35.1054777623799,
    LX: 129.021176962456,
    LY: 35.0956754343596,
    RX: 129.044443237465,
    RY: 35.116604500365,
    SID_CD: "26",
  },
  {
    SIG_KOR_NM: "해운대구",
    SIG_CD: "26350",
    LON: 129.153593104148,
    LAT: 35.1938535604466,
    LX: 129.110240053969,
    LY: 35.1518462168902,
    RX: 129.208410609218,
    RY: 35.2509679064387,
    SID_CD: "26",
  },
  {
    SIG_KOR_NM: "남구",
    SIG_CD: "27200",
    LON: 128.585329568543,
    LAT: 35.8351771540195,
    LX: 128.555384548866,
    LY: 35.8073464858165,
    RX: 128.608884052612,
    RY: 35.8601840366532,
    SID_CD: "27",
  },
  {
    SIG_KOR_NM: "달서구",
    SIG_CD: "27290",
    LON: 128.529211814164,
    LAT: 35.8274832947561,
    LX: 128.468694577217,
    LY: 35.7729288067927,
    RX: 128.5876185419,
    RY: 35.8695952911782,
    SID_CD: "27",
  },
  {
    SIG_KOR_NM: "달성군",
    SIG_CD: "27710",
    LON: 128.498295335466,
    LAT: 35.7595730189555,
    LX: 128.351475712983,
    LY: 35.606539898192,
    RX: 128.695485634125,
    RY: 35.9431494384394,
    SID_CD: "27",
  },
  {
    SIG_KOR_NM: "동구",
    SIG_CD: "27140",
    LON: 128.685659428549,
    LAT: 35.9344266138083,
    LX: 128.60335923054,
    LY: 35.8511606480706,
    RX: 128.762692673875,
    RY: 36.0161651167155,
    SID_CD: "27",
  },
  {
    SIG_KOR_NM: "북구",
    SIG_CD: "27230",
    LON: 128.577203987438,
    LAT: 35.9289223336016,
    LX: 128.504170151384,
    LY: 35.8737341538364,
    RX: 128.632477982514,
    RY: 35.9879873437446,
    SID_CD: "27",
  },
  {
    SIG_KOR_NM: "서구",
    SIG_CD: "27170",
    LON: 128.549697486384,
    LAT: 35.8750016682987,
    LX: 128.516343280465,
    LY: 35.8544827441729,
    RX: 128.5819140877,
    RY: 35.8956500987279,
    SID_CD: "27",
  },
  {
    SIG_KOR_NM: "수성구",
    SIG_CD: "27260",
    LON: 128.661273895061,
    LAT: 35.8338488816766,
    LX: 128.591682373135,
    LY: 35.7898760062374,
    RX: 128.72691871252,
    RY: 35.8783599598773,
    SID_CD: "27",
  },
  {
    SIG_KOR_NM: "중구",
    SIG_CD: "27110",
    LON: 128.593605776424,
    LAT: 35.8665352903466,
    LX: 128.573852990341,
    LY: 35.8549328069173,
    RX: 128.614767147828,
    RY: 35.8794787007776,
    SID_CD: "27",
  },
  {
    SIG_KOR_NM: "강화군",
    SIG_CD: "28710",
    LON: 126.401827149374,
    LAT: 37.7129271837621,
    LX: 125.958744869915,
    LY: 37.5810180529941,
    RX: 126.543960408918,
    RY: 37.8321973938552,
    SID_CD: "28",
  },
  {
    SIG_KOR_NM: "계양구",
    SIG_CD: "28245",
    LON: 126.734700093081,
    LAT: 37.5572970121023,
    LX: 126.681055793582,
    LY: 37.5234502707699,
    RX: 126.793695444358,
    RY: 37.5937028212488,
    SID_CD: "28",
  },
  {
    SIG_KOR_NM: "남구",
    SIG_CD: "28170",
    LON: 126.664658608308,
    LAT: 37.4525957870283,
    LX: 126.629010805827,
    LY: 37.4299894603426,
    RX: 126.702939358186,
    RY: 37.4840328498436,
    SID_CD: "28",
  },
  {
    SIG_KOR_NM: "남동구",
    SIG_CD: "28200",
    LON: 126.726461148678,
    LAT: 37.4313489774185,
    LX: 126.667427020429,
    LY: 37.382504186909,
    RX: 126.78043223036,
    RY: 37.4799367328361,
    SID_CD: "28",
  },
  {
    SIG_KOR_NM: "동구",
    SIG_CD: "28140",
    LON: 126.6397466911,
    LAT: 37.482986567721,
    LX: 126.609904668027,
    LY: 37.4683889460878,
    RX: 126.674430853792,
    RY: 37.4957730451068,
    SID_CD: "28",
  },
  {
    SIG_KOR_NM: "부평구",
    SIG_CD: "28237",
    LON: 126.721209556571,
    LAT: 37.4966587226331,
    LX: 126.683248523456,
    LY: 37.4644821103292,
    RX: 126.767753454466,
    RY: 37.5240816467253,
    SID_CD: "28",
  },
  {
    SIG_KOR_NM: "서구",
    SIG_CD: "28260",
    LON: 126.658947745902,
    LAT: 37.55891231833,
    LX: 126.525579044142,
    LY: 37.4709347884098,
    RX: 126.725665472012,
    RY: 37.6394886171283,
    SID_CD: "28",
  },
  {
    SIG_KOR_NM: "연수구",
    SIG_CD: "28185",
    LON: 126.647762480909,
    LAT: 37.3983257274334,
    LX: 126.583048283758,
    LY: 37.3418071126055,
    RX: 126.706655080344,
    RY: 37.4394256816895,
    SID_CD: "28",
  },
  {
    SIG_KOR_NM: "옹진군",
    SIG_CD: "28720",
    LON: 125.636586999847,
    LAT: 37.5437357101378,
    LX: 124.60970878555,
    LY: 36.9199481980454,
    RX: 126.69509431128,
    RY: 37.9842101996516,
    SID_CD: "28",
  },
  {
    SIG_KOR_NM: "중구",
    SIG_CD: "28110",
    LON: 126.480562623015,
    LAT: 37.4675343967619,
    LX: 126.355785003513,
    LY: 37.3569076090635,
    RX: 126.644201379632,
    RY: 37.5424054097759,
    SID_CD: "28",
  },
  {
    SIG_KOR_NM: "광산구",
    SIG_CD: "29200",
    LON: 126.752895983929,
    LAT: 35.1650351529289,
    LX: 126.644702845769,
    LY: 35.0701702072086,
    RX: 126.860409139866,
    RY: 35.258703976044,
    SID_CD: "29",
  },
  {
    SIG_KOR_NM: "남구",
    SIG_CD: "29155",
    LON: 126.856718679842,
    LAT: 35.0940585712777,
    LX: 126.753136435252,
    LY: 35.0508954278839,
    RX: 126.929628483628,
    RY: 35.1524990115626,
    SID_CD: "29",
  },
  {
    SIG_KOR_NM: "동구",
    SIG_CD: "29110",
    LON: 126.949464359901,
    LAT: 35.1173802023878,
    LX: 126.907153489064,
    LY: 35.0724679928126,
    RX: 127.004318021113,
    RY: 35.1654890180756,
    SID_CD: "29",
  },
  {
    SIG_KOR_NM: "북구",
    SIG_CD: "29170",
    LON: 126.925486965964,
    LAT: 35.1932458215095,
    LX: 126.834855492749,
    LY: 35.121290636929,
    RX: 127.022275223828,
    RY: 35.2584677250652,
    SID_CD: "29",
  },
  {
    SIG_KOR_NM: "서구",
    SIG_CD: "29140",
    LON: 126.850719258235,
    LAT: 35.135693196683,
    LX: 126.800630421924,
    LY: 35.0907207477574,
    RX: 126.909742738524,
    RY: 35.1786073101745,
    SID_CD: "29",
  },
  {
    SIG_KOR_NM: "대덕구",
    SIG_CD: "30230",
    LON: 127.44015181447,
    LAT: 36.4121786909813,
    LX: 127.389301314546,
    LY: 36.3409270316057,
    RX: 127.504471920703,
    RY: 36.4772099878446,
    SID_CD: "30",
  },
  {
    SIG_KOR_NM: "동구",
    SIG_CD: "30110",
    LON: 127.475037415012,
    LAT: 36.3239202445626,
    LX: 127.413651070142,
    LY: 36.1947463606893,
    RX: 127.559678713219,
    RY: 36.4400080867327,
    SID_CD: "30",
  },
  {
    SIG_KOR_NM: "서구",
    SIG_CD: "30170",
    LON: 127.345104133253,
    LAT: 36.280239699193,
    LX: 127.279040498354,
    LY: 36.1831000575531,
    RX: 127.404610800536,
    RY: 36.3720152258085,
    SID_CD: "30",
  },
  {
    SIG_KOR_NM: "유성구",
    SIG_CD: "30200",
    LON: 127.333256467128,
    LAT: 36.3767906608128,
    LX: 127.246652706568,
    LY: 36.264163388327,
    RX: 127.420265079252,
    RY: 36.5002306413433,
    SID_CD: "30",
  },
  {
    SIG_KOR_NM: "중구",
    SIG_CD: "30140",
    LON: 127.411057306708,
    LAT: 36.2808601489354,
    LX: 127.367532620008,
    LY: 36.2071269103369,
    RX: 127.459058401306,
    RY: 36.3496313252652,
    SID_CD: "30",
  },
  {
    SIG_KOR_NM: "남구",
    SIG_CD: "31140",
    LON: 129.328201273027,
    LAT: 35.5160504663718,
    LX: 129.236539466041,
    LY: 35.4577909940479,
    RX: 129.388901382367,
    RY: 35.5569105350709,
    SID_CD: "31",
  },
  {
    SIG_KOR_NM: "동구",
    SIG_CD: "31170",
    LON: 129.426065496302,
    LAT: 35.5255734762994,
    LX: 129.387664176457,
    LY: 35.4715181480206,
    RX: 129.458232927319,
    RY: 35.5715402323312,
    SID_CD: "31",
  },
  {
    SIG_KOR_NM: "북구",
    SIG_CD: "31200",
    LON: 129.379809313049,
    LAT: 35.6100542989088,
    LX: 129.289421969827,
    LY: 35.5160075693153,
    RX: 129.463857344231,
    RY: 35.6794395251167,
    SID_CD: "31",
  },
  {
    SIG_KOR_NM: "울주군",
    SIG_CD: "31710",
    LON: 129.186921452024,
    LAT: 35.5466208316458,
    LX: 128.971190343508,
    LY: 35.3293263009998,
    RX: 129.368257687572,
    RY: 35.7249197895119,
    SID_CD: "31",
  },
  {
    SIG_KOR_NM: "중구",
    SIG_CD: "31110",
    LON: 129.308242267022,
    LAT: 35.5710493217027,
    LX: 129.252617680483,
    LY: 35.544903051397,
    RX: 129.353680292592,
    RY: 35.5991120249031,
    SID_CD: "31",
  },
  {
    SIG_KOR_NM: "세종특별자치시",
    SIG_CD: "36110",
    LON: 127.258780178997,
    LAT: 36.5606573846866,
    LX: 127.127729913635,
    LY: 36.4067584014928,
    RX: 127.410803579213,
    RY: 36.7338218782274,
    SID_CD: "36",
  },
  {
    SIG_KOR_NM: "가평군",
    SIG_CD: "41820",
    LON: 127.450192233691,
    LAT: 37.8184331704755,
    LX: 127.266914039986,
    LY: 37.5711466699089,
    RX: 127.617141236778,
    RY: 38.0512301677332,
    SID_CD: "41",
  },
  {
    SIG_KOR_NM: "고양시덕양구",
    SIG_CD: "41281",
    LON: 126.878632609281,
    LAT: 37.6558101096798,
    LX: 126.759520425827,
    LY: 37.5717904914677,
    RX: 126.994357631867,
    RY: 37.7484850085622,
    SID_CD: "41",
  },
  {
    SIG_KOR_NM: "고양시일산동구",
    SIG_CD: "41285",
    LON: 126.79755832628,
    LAT: 37.679865313162,
    LX: 126.732460070106,
    LY: 37.625609479494,
    RX: 126.856062129874,
    RY: 37.7370441548115,
    SID_CD: "41",
  },
  {
    SIG_KOR_NM: "고양시일산서구",
    SIG_CD: "41287",
    LON: 126.727983785395,
    LAT: 37.6802051382942,
    LX: 126.670356092149,
    LY: 37.6475214768492,
    RX: 126.781796014501,
    RY: 37.7072839868638,
    SID_CD: "41",
  },
  {
    SIG_KOR_NM: "과천시",
    SIG_CD: "41290",
    LON: 127.002679558574,
    LAT: 37.4338452928231,
    LX: 126.960908745791,
    LY: 37.4005917118345,
    RX: 127.047369237085,
    RY: 37.4677203855848,
    SID_CD: "41",
  },
  {
    SIG_KOR_NM: "광명시",
    SIG_CD: "41210",
    LON: 126.864701341389,
    LAT: 37.4451590489393,
    LX: 126.826101159141,
    LY: 37.401524364132,
    RX: 126.899925913643,
    RY: 37.4951283019023,
    SID_CD: "41",
  },
  {
    SIG_KOR_NM: "광주시",
    SIG_CD: "41610",
    LON: 127.30117626784,
    LAT: 37.4030907253668,
    LX: 127.132596883449,
    LY: 37.2650179289172,
    RX: 127.446638066949,
    RY: 37.5358645319766,
    SID_CD: "41",
  },
  {
    SIG_KOR_NM: "구리시",
    SIG_CD: "41310",
    LON: 127.131230473833,
    LAT: 37.5992204233539,
    LX: 127.100887864816,
    LY: 37.5563353341136,
    RX: 127.170598030137,
    RY: 37.6460811208791,
    SID_CD: "41",
  },
  {
    SIG_KOR_NM: "군포시",
    SIG_CD: "41410",
    LON: 126.921134775874,
    LAT: 37.3434827308379,
    LX: 126.872764291033,
    LY: 37.3050543615878,
    RX: 126.962841328969,
    RY: 37.3786723711946,
    SID_CD: "41",
  },
  {
    SIG_KOR_NM: "김포시",
    SIG_CD: "41570",
    LON: 126.626444358863,
    LAT: 37.6817775367792,
    LX: 126.517049859582,
    LY: 37.5795704694197,
    RX: 126.802581404508,
    RY: 37.7900981580292,
    SID_CD: "41",
  },
  {
    SIG_KOR_NM: "남양주시",
    SIG_CD: "41360",
    LON: 127.243661077285,
    LAT: 37.662529707708,
    LX: 127.080232600238,
    LY: 37.5054994561736,
    RX: 127.380986164707,
    RY: 37.7805275879525,
    SID_CD: "41",
  },
  {
    SIG_KOR_NM: "동두천시",
    SIG_CD: "41250",
    LON: 127.077912903033,
    LAT: 37.9165375250921,
    LX: 127.006220584984,
    LY: 37.8603412248263,
    RX: 127.155370797368,
    RY: 37.9810492585767,
    SID_CD: "41",
  },
  {
    SIG_KOR_NM: "부천시소사구",
    SIG_CD: "41197",
    LON: 126.796809174027,
    LAT: 37.4749368697514,
    LX: 126.742310374548,
    LY: 37.4583756188598,
    RX: 126.833600690821,
    RY: 37.4907023403264,
    SID_CD: "41",
  },
  {
    SIG_KOR_NM: "부천시오정구",
    SIG_CD: "41199",
    LON: 126.793524540588,
    LAT: 37.5275584607318,
    LX: 126.759988560442,
    LY: 37.5057386593161,
    RX: 126.82883740205,
    RY: 37.5542423752168,
    SID_CD: "41",
  },
  {
    SIG_KOR_NM: "부천시원미구",
    SIG_CD: "41195",
    LON: 126.778955437628,
    LAT: 37.4997978979426,
    LX: 126.741470751408,
    LY: 37.4822553093754,
    RX: 126.822550536788,
    RY: 37.5223330179765,
    SID_CD: "41",
  },
  {
    SIG_KOR_NM: "성남시 분당구",
    SIG_CD: "41135",
    LON: 127.10606422618,
    LAT: 37.3793015794486,
    LX: 127.027704818143,
    LY: 37.33337490398,
    RX: 127.177246091371,
    RY: 37.4173190032037,
    SID_CD: "41",
  },
  {
    SIG_KOR_NM: "성남시 수정구",
    SIG_CD: "41131",
    LON: 127.104132750041,
    LAT: 37.4351754925074,
    LX: 127.041765626401,
    LY: 37.3956050773405,
    RX: 127.176930251711,
    RY: 37.4757991795019,
    SID_CD: "41",
  },
  {
    SIG_KOR_NM: "성남시 중원구",
    SIG_CD: "41133",
    LON: 127.163909961976,
    LAT: 37.4334332534557,
    LX: 127.116979386503,
    LY: 37.4051891415888,
    RX: 127.1958191463,
    RY: 37.4748092673225,
    SID_CD: "41",
  },
  {
    SIG_KOR_NM: "수원시 권선구",
    SIG_CD: "41113",
    LON: 126.979744025287,
    LAT: 37.2605300587878,
    LX: 126.926980973347,
    LY: 37.224544248546,
    RX: 127.042171360565,
    RY: 37.3033387834847,
    SID_CD: "41",
  },
  {
    SIG_KOR_NM: "수원시 영통구",
    SIG_CD: "41117",
    LON: 127.056698861508,
    LAT: 37.2749903752691,
    LX: 127.032390579458,
    LY: 37.2312764143041,
    RX: 127.089631991402,
    RY: 37.3209954504266,
    SID_CD: "41",
  },
  {
    SIG_KOR_NM: "수원시 장안구",
    SIG_CD: "41111",
    LON: 127.003451779885,
    LAT: 37.3139657200142,
    LX: 126.960341423766,
    LY: 37.2851927409388,
    RX: 127.03977386352,
    RY: 37.3510448961688,
    SID_CD: "41",
  },
  {
    SIG_KOR_NM: "수원시 팔달구",
    SIG_CD: "41115",
    LON: 127.016238725853,
    LAT: 37.2774636195237,
    LX: 126.97733752949,
    LY: 37.2565209790944,
    RX: 127.045965432903,
    RY: 37.2936094894946,
    SID_CD: "41",
  },
  {
    SIG_KOR_NM: "시흥시",
    SIG_CD: "41390",
    LON: 126.788393350526,
    LAT: 37.3893977110799,
    LX: 126.685383710301,
    LY: 37.3145938365138,
    RX: 126.881644389469,
    RY: 37.4723932294974,
    SID_CD: "41",
  },
  {
    SIG_KOR_NM: "안산시단원구",
    SIG_CD: "41273",
    LON: 126.694045796869,
    LAT: 37.2819274040191,
    LX: 126.380101621543,
    LY: 37.0804695256775,
    RX: 126.843143164906,
    RY: 37.3659065064429,
    SID_CD: "41",
  },
  {
    SIG_KOR_NM: "안산시상록구",
    SIG_CD: "41271",
    LON: 126.870815169698,
    LAT: 37.3160038213418,
    LX: 126.814508169248,
    LY: 37.2684387488345,
    RX: 126.939610232565,
    RY: 37.3774661213016,
    SID_CD: "41",
  },
  {
    SIG_KOR_NM: "안성시",
    SIG_CD: "41550",
    LON: 127.302723025477,
    LAT: 37.0350271654922,
    LX: 127.102015966979,
    LY: 36.893775017516,
    RX: 127.516591453447,
    RY: 37.1558890668418,
    SID_CD: "41",
  },
  {
    SIG_KOR_NM: "안양시동안구",
    SIG_CD: "41173",
    LON: 126.955502720006,
    LAT: 37.4003918276139,
    LX: 126.927357584736,
    LY: 37.3616354467604,
    RX: 126.982854924934,
    RY: 37.4407869847667,
    SID_CD: "41",
  },
  {
    SIG_KOR_NM: "안양시만안구",
    SIG_CD: "41171",
    LON: 126.911206175578,
    LAT: 37.4038753638345,
    LX: 126.870241982372,
    LY: 37.3583317540763,
    RX: 126.948943150579,
    RY: 37.4502126606686,
    SID_CD: "41",
  },
  {
    SIG_KOR_NM: "양주시",
    SIG_CD: "41630",
    LON: 127.001135230274,
    LAT: 37.8086577672599,
    LX: 126.90195443991,
    LY: 37.6686853421189,
    RX: 127.122192559453,
    RY: 37.9421194839074,
    SID_CD: "41",
  },
  {
    SIG_KOR_NM: "양평군",
    SIG_CD: "41830",
    LON: 127.579263918699,
    LAT: 37.5180559521791,
    LX: 127.305922732456,
    LY: 37.3670128460265,
    RX: 127.84811314587,
    RY: 37.6707927437915,
    SID_CD: "41",
  },
  {
    SIG_KOR_NM: "여주시",
    SIG_CD: "41670",
    LON: 127.615737061053,
    LAT: 37.3024585346226,
    LX: 127.398219445169,
    LY: 37.1350554980657,
    RX: 127.768411722773,
    RY: 37.4404263166569,
    SID_CD: "41",
  },
  {
    SIG_KOR_NM: "연천군",
    SIG_CD: "41800",
    LON: 127.024457855531,
    LAT: 38.0927307418996,
    LX: 126.785770378611,
    LY: 37.9282167200435,
    RX: 127.192155862056,
    RY: 38.282260548686,
    SID_CD: "41",
  },
  {
    SIG_KOR_NM: "오산시",
    SIG_CD: "41370",
    LON: 127.051329756194,
    LAT: 37.1632906184057,
    LX: 126.994914010775,
    LY: 37.1253234873742,
    RX: 127.103092772084,
    RY: 37.2008728920247,
    SID_CD: "41",
  },
  {
    SIG_KOR_NM: "용인시기흥구",
    SIG_CD: "41463",
    LON: 127.121321613864,
    LAT: 37.2674266749949,
    LX: 127.064724736494,
    LY: 37.2155325141463,
    RX: 127.177127943058,
    RY: 37.3247224514167,
    SID_CD: "41",
  },
  {
    SIG_KOR_NM: "용인시수지구",
    SIG_CD: "41465",
    LON: 127.071551216344,
    LAT: 37.3334473781954,
    LX: 127.016485743183,
    LY: 37.2932310588572,
    RX: 127.142444474573,
    RY: 37.3723203543289,
    SID_CD: "41",
  },
  {
    SIG_KOR_NM: "용인시처인구",
    SIG_CD: "41461",
    LON: 127.252933587869,
    LAT: 37.2033317929395,
    LX: 127.108727748578,
    LY: 37.0836357693407,
    RX: 127.427754089759,
    RY: 37.3604419619856,
    SID_CD: "41",
  },
  {
    SIG_KOR_NM: "의왕시",
    SIG_CD: "41430",
    LON: 126.989625558068,
    LAT: 37.3623879284264,
    LX: 126.929311602634,
    LY: 37.3003213715375,
    RX: 127.047113337929,
    RY: 37.4156127321469,
    SID_CD: "41",
  },
  {
    SIG_KOR_NM: "의정부시",
    SIG_CD: "41150",
    LON: 127.068423298616,
    LAT: 37.7361921480384,
    LX: 127.001694129166,
    LY: 37.6858135634925,
    RX: 127.147256558613,
    RY: 37.7803039268485,
    SID_CD: "41",
  },
  {
    SIG_KOR_NM: "이천시",
    SIG_CD: "41500",
    LON: 127.481014152412,
    LAT: 37.2097758614855,
    LX: 127.330031085983,
    LY: 37.0412468834179,
    RX: 127.637776713832,
    RY: 37.3617031827123,
    SID_CD: "41",
  },
  {
    SIG_KOR_NM: "파주시",
    SIG_CD: "41480",
    LON: 126.810751721036,
    LAT: 37.8561927306238,
    LX: 126.659318028425,
    LY: 37.6886057239198,
    RX: 127.017107133317,
    RY: 38.0105907390068,
    SID_CD: "41",
  },
  {
    SIG_KOR_NM: "평택시",
    SIG_CD: "41220",
    LON: 126.995326992672,
    LAT: 37.0161626193367,
    LX: 126.779010707898,
    LY: 36.9015956427269,
    RX: 127.154527252243,
    RY: 37.1446734206909,
    SID_CD: "41",
  },
  {
    SIG_KOR_NM: "포천시",
    SIG_CD: "41650",
    LON: 127.250337549075,
    LAT: 37.9697784903165,
    LX: 127.08979615585,
    LY: 37.7469292338735,
    RX: 127.447075940993,
    RY: 38.1883212295737,
    SID_CD: "41",
  },
  {
    SIG_KOR_NM: "하남시",
    SIG_CD: "41450",
    LON: 127.205944761482,
    LAT: 37.5228125308022,
    LX: 127.139329866932,
    LY: 37.4687718590267,
    RX: 127.285701348502,
    RY: 37.5917688805835,
    SID_CD: "41",
  },
  {
    SIG_KOR_NM: "화성시",
    SIG_CD: "41590",
    LON: 126.875154993679,
    LAT: 37.165332289133,
    LX: 126.528268754126,
    LY: 37.0133760816161,
    RX: 127.161367327525,
    RY: 37.3032689183358,
    SID_CD: "41",
  },
  {
    SIG_KOR_NM: "강릉시",
    SIG_CD: "42150",
    LON: 128.832373154453,
    LAT: 37.7091063504888,
    LX: 128.580359707536,
    LY: 37.5032959062753,
    RX: 129.074046150702,
    RY: 37.9171729111229,
    SID_CD: "42",
  },
  {
    SIG_KOR_NM: "고성군",
    SIG_CD: "42820",
    LON: 128.411154621739,
    LAT: 38.3627553010633,
    LX: 128.242892200569,
    LY: 38.1873313500884,
    RX: 128.584907387017,
    RY: 38.6137093097644,
    SID_CD: "42",
  },
  {
    SIG_KOR_NM: "동해시",
    SIG_CD: "42170",
    LON: 129.055567528236,
    LAT: 37.506680993,
    LX: 128.957618471571,
    LY: 37.4267975907696,
    RX: 129.160713693523,
    RY: 37.6045388273171,
    SID_CD: "42",
  },
  {
    SIG_KOR_NM: "삼척시",
    SIG_CD: "42230",
    LON: 129.121701468962,
    LAT: 37.2774860648898,
    LX: 128.845935557622,
    LY: 37.0386653086019,
    RX: 129.363781278381,
    RY: 37.4763836423608,
    SID_CD: "42",
  },
  {
    SIG_KOR_NM: "속초시",
    SIG_CD: "42210",
    LON: 128.51953999683,
    LAT: 38.1760311691178,
    LX: 128.421140093924,
    LY: 38.118953225758,
    RX: 128.614454451888,
    RY: 38.2307645526697,
    SID_CD: "42",
  },
  {
    SIG_KOR_NM: "양구군",
    SIG_CD: "42800",
    LON: 128.000205570716,
    LAT: 38.1756086004702,
    LX: 127.851745373943,
    LY: 38.0016246405085,
    RX: 128.172391001753,
    RY: 38.3373059399569,
    SID_CD: "42",
  },
  {
    SIG_KOR_NM: "양양군",
    SIG_CD: "42830",
    LON: 128.595005898954,
    LAT: 38.0044876690617,
    LX: 128.404246676245,
    LY: 37.8620186025509,
    RX: 128.809188202512,
    RY: 38.1618908783123,
    SID_CD: "42",
  },
  {
    SIG_KOR_NM: "영월군",
    SIG_CD: "42750",
    LON: 128.500277422176,
    LAT: 37.2041212169194,
    LX: 128.107162441367,
    LY: 37.0278324898817,
    RX: 128.910416615579,
    RY: 37.4089613846103,
    SID_CD: "42",
  },
  {
    SIG_KOR_NM: "원주시",
    SIG_CD: "42130",
    LON: 127.92952324174,
    LAT: 37.3082228175207,
    LX: 127.744100654979,
    LY: 37.1434082762157,
    RX: 128.218455261744,
    RY: 37.5069099341141,
    SID_CD: "42",
  },
  {
    SIG_KOR_NM: "인제군",
    SIG_CD: "42810",
    LON: 128.264724796502,
    LAT: 38.0646005354186,
    LX: 127.97751228424,
    LY: 37.8119958085986,
    RX: 128.513574212814,
    RY: 38.378966292092,
    SID_CD: "42",
  },
  {
    SIG_KOR_NM: "정선군",
    SIG_CD: "42770",
    LON: 128.739058385822,
    LAT: 37.378686106801,
    LX: 128.505973795764,
    LY: 37.1470773245191,
    RX: 128.989662734386,
    RY: 37.5929158537957,
    SID_CD: "42",
  },
  {
    SIG_KOR_NM: "철원군",
    SIG_CD: "42780",
    LON: 127.398925386135,
    LAT: 38.2390851519391,
    LX: 127.095037641112,
    LY: 38.089768545804,
    RX: 127.846640722263,
    RY: 38.3478154495165,
    SID_CD: "42",
  },
  {
    SIG_KOR_NM: "춘천시",
    SIG_CD: "42110",
    LON: 127.739866901664,
    LAT: 37.8897962782989,
    LX: 127.506148125059,
    LY: 37.6756449183198,
    RX: 128.029608255292,
    RY: 38.0850253423914,
    SID_CD: "42",
  },
  {
    SIG_KOR_NM: "태백시",
    SIG_CD: "42190",
    LON: 128.980071971364,
    LAT: 37.1723128125082,
    LX: 128.867161808854,
    LY: 37.0616850543478,
    RX: 129.095660301323,
    RY: 37.3455928397651,
    SID_CD: "42",
  },
  {
    SIG_KOR_NM: "평창군",
    SIG_CD: "42760",
    LON: 128.482585500245,
    LAT: 37.5568353236271,
    LX: 128.243529226704,
    LY: 37.2666345996984,
    RX: 128.7651107341,
    RY: 37.8213850792694,
    SID_CD: "42",
  },
  {
    SIG_KOR_NM: "홍천군",
    SIG_CD: "42720",
    LON: 128.074243682483,
    LAT: 37.7450460028679,
    LX: 127.535244647573,
    LY: 37.5522627607006,
    RX: 128.588795499739,
    RY: 37.9455199391543,
    SID_CD: "42",
  },
  {
    SIG_KOR_NM: "화천군",
    SIG_CD: "42790",
    LON: 127.685164734545,
    LAT: 38.1384262166208,
    LX: 127.430532025535,
    LY: 37.9942868598902,
    RX: 127.913638281888,
    RY: 38.2880570885033,
    SID_CD: "42",
  },
  {
    SIG_KOR_NM: "횡성군",
    SIG_CD: "42730",
    LON: 128.07706376696,
    LAT: 37.5091420634644,
    LX: 127.759421490315,
    LY: 37.2988042714819,
    RX: 128.302266704445,
    RY: 37.6801598662576,
    SID_CD: "42",
  },
  {
    SIG_KOR_NM: "괴산군",
    SIG_CD: "43760",
    LON: 127.829586798111,
    LAT: 36.7696590580494,
    LX: 127.620458305743,
    LY: 36.6011183216079,
    RX: 128.072723796199,
    RY: 36.9475536077362,
    SID_CD: "43",
  },
  {
    SIG_KOR_NM: "단양군",
    SIG_CD: "43800",
    LON: 128.387839159156,
    LAT: 36.9944518125234,
    LX: 128.217124937611,
    LY: 36.8020760341617,
    RX: 128.652096498765,
    RY: 37.1582061829968,
    SID_CD: "43",
  },
  {
    SIG_KOR_NM: "보은군",
    SIG_CD: "43720",
    LON: 127.729334857757,
    LAT: 36.4899496354638,
    LX: 127.514512830078,
    LY: 36.3689744711397,
    RX: 127.906336327191,
    RY: 36.6137739201891,
    SID_CD: "43",
  },
  {
    SIG_KOR_NM: "영동군",
    SIG_CD: "43740",
    LON: 127.814226703753,
    LAT: 36.1596586848478,
    LX: 127.589437054747,
    LY: 36.0122068350246,
    RX: 128.058146169897,
    RY: 36.3166397226793,
    SID_CD: "43",
  },
  {
    SIG_KOR_NM: "옥천군",
    SIG_CD: "43730",
    LON: 127.656558243149,
    LAT: 36.3204559734736,
    LX: 127.486048354473,
    LY: 36.1707095604754,
    RX: 127.891271213671,
    RY: 36.4452886529828,
    SID_CD: "43",
  },
  {
    SIG_KOR_NM: "음성군",
    SIG_CD: "43770",
    LON: 127.614207034427,
    LAT: 36.9762228975313,
    LX: 127.445348123341,
    LY: 36.8338301754601,
    RX: 127.798481260808,
    RY: 37.1552865872571,
    SID_CD: "43",
  },
  {
    SIG_KOR_NM: "제천시",
    SIG_CD: "43150",
    LON: 128.140958558509,
    LAT: 37.0599125338727,
    LX: 127.921583346455,
    LY: 36.8116952284107,
    RX: 128.333396586534,
    RY: 37.2583342821431,
    SID_CD: "43",
  },
  {
    SIG_KOR_NM: "증평군",
    SIG_CD: "43745",
    LON: 127.604618074174,
    LAT: 36.7864730503138,
    LX: 127.537327149229,
    LY: 36.7012806334714,
    RX: 127.664599868082,
    RY: 36.8600751211459,
    SID_CD: "43",
  },
  {
    SIG_KOR_NM: "진천군",
    SIG_CD: "43750",
    LON: 127.440464461494,
    LAT: 36.8709997414221,
    LX: 127.287828866179,
    LY: 36.7487255476303,
    RX: 127.585159665095,
    RY: 37.0121136508885,
    SID_CD: "43",
  },
  {
    SIG_KOR_NM: "청주시 상당구",
    SIG_CD: "43111",
    LON: 127.584879941117,
    LAT: 36.5921122232697,
    LX: 127.445264007893,
    LY: 36.4082061515646,
    RX: 127.76978231827,
    RY: 36.7299931961481,
    SID_CD: "43",
  },
  {
    SIG_KOR_NM: "청주시 서원구",
    SIG_CD: "43112",
    LON: 127.438400677796,
    LAT: 36.5472630625253,
    LX: 127.372041780267,
    LY: 36.4491947205972,
    RX: 127.499624769796,
    RY: 36.6466245043825,
    SID_CD: "43",
  },
  {
    SIG_KOR_NM: "청주시 청원구",
    SIG_CD: "43114",
    LON: 127.491317651734,
    LAT: 36.7205788984791,
    LX: 127.317993027339,
    LY: 36.6448359916094,
    RX: 127.618914503602,
    RY: 36.7802634431741,
    SID_CD: "43",
  },
  {
    SIG_KOR_NM: "청주시 흥덕구",
    SIG_CD: "43113",
    LON: 127.369274975599,
    LAT: 36.6469607603547,
    LX: 127.27565045697,
    LY: 36.5616845283687,
    RX: 127.481855453348,
    RY: 36.7249158577739,
    SID_CD: "43",
  },
  {
    SIG_KOR_NM: "충주시",
    SIG_CD: "43130",
    LON: 127.895660392594,
    LAT: 37.0151978250038,
    LX: 127.650851087083,
    LY: 36.7966375274696,
    RX: 128.134044097294,
    RY: 37.2148608640034,
    SID_CD: "43",
  },
  {
    SIG_KOR_NM: "계룡시",
    SIG_CD: "44250",
    LON: 127.234426627843,
    LAT: 36.2915936589957,
    LX: 127.196346454661,
    LY: 36.2317605444681,
    RX: 127.291915963206,
    RY: 36.3502488188728,
    SID_CD: "44",
  },
  {
    SIG_KOR_NM: "공주시",
    SIG_CD: "44150",
    LON: 127.075220106543,
    LAT: 36.4798190304577,
    LX: 126.883572742797,
    LY: 36.2771206064537,
    RX: 127.282296744268,
    RY: 36.6792470214688,
    SID_CD: "44",
  },
  {
    SIG_KOR_NM: "금산군",
    SIG_CD: "44710",
    LON: 127.478311958409,
    LAT: 36.1190007943025,
    LX: 127.318014797133,
    LY: 35.9782641242881,
    RX: 127.63974825415,
    RY: 36.2721886537926,
    SID_CD: "44",
  },
  {
    SIG_KOR_NM: "논산시",
    SIG_CD: "44230",
    LON: 127.157717259251,
    LAT: 36.1908868461861,
    LX: 126.98365108243,
    LY: 36.0630333074491,
    RX: 127.333568802309,
    RY: 36.3402850808318,
    SID_CD: "44",
  },
  {
    SIG_KOR_NM: "당진시",
    SIG_CD: "44270",
    LON: 126.652748142941,
    LAT: 36.9032560458032,
    LX: 126.402599012026,
    LY: 36.7492620811568,
    RX: 126.859061711988,
    RY: 37.0647537433522,
    SID_CD: "44",
  },
  {
    SIG_KOR_NM: "보령시",
    SIG_CD: "44180",
    LON: 126.594556010053,
    LAT: 36.3414729524766,
    LX: 125.955422373031,
    LY: 36.1718616364918,
    RX: 126.738715130546,
    RY: 36.524791365929,
    SID_CD: "44",
  },
  {
    SIG_KOR_NM: "부여군",
    SIG_CD: "44760",
    LON: 126.856969774053,
    LAT: 36.2463834265231,
    LX: 126.678452269682,
    LY: 36.0710323276096,
    RX: 127.070307869154,
    RY: 36.3870422513717,
    SID_CD: "44",
  },
  {
    SIG_KOR_NM: "서산시",
    SIG_CD: "44210",
    LON: 126.463602707855,
    LAT: 36.7839925946809,
    LX: 126.315875216492,
    LY: 36.6004018840711,
    RX: 126.653620773551,
    RY: 37.0265305502468,
    SID_CD: "44",
  },
  {
    SIG_KOR_NM: "서천군",
    SIG_CD: "44770",
    LON: 126.708037626194,
    LAT: 36.1051645633358,
    LX: 126.468606631982,
    LY: 35.9909745445146,
    RX: 126.871085308355,
    RY: 36.1900906060755,
    SID_CD: "44",
  },
  {
    SIG_KOR_NM: "아산시",
    SIG_CD: "44200",
    LON: 126.98007646398,
    LAT: 36.8073163949887,
    LX: 126.829093592645,
    LY: 36.6486117319933,
    RX: 127.119713975361,
    RY: 36.9422412181716,
    SID_CD: "44",
  },
  {
    SIG_KOR_NM: "예산군",
    SIG_CD: "44810",
    LON: 126.784313528765,
    LAT: 36.6706278833907,
    LX: 126.585324504942,
    LY: 36.5266632856565,
    RX: 126.972343645558,
    RY: 36.8037213730292,
    SID_CD: "44",
  },
  {
    SIG_KOR_NM: "천안시동남구",
    SIG_CD: "44131",
    LON: 127.220895655907,
    LAT: 36.7641177474211,
    LX: 127.008363878288,
    LY: 36.6197495483075,
    RX: 127.420417064029,
    RY: 36.8921969821902,
    SID_CD: "44",
  },
  {
    SIG_KOR_NM: "천안시서북구",
    SIG_CD: "44133",
    LON: 127.161809678371,
    LAT: 36.8927106876071,
    LX: 127.074082412328,
    LY: 36.7849269353269,
    RX: 127.290588043311,
    RY: 36.9730740752526,
    SID_CD: "44",
  },
  {
    SIG_KOR_NM: "청양군",
    SIG_CD: "44790",
    LON: 126.853114970791,
    LAT: 36.4305825618691,
    LX: 126.671929676599,
    LY: 36.3144981798622,
    RX: 127.028246009119,
    RY: 36.5718119093653,
    SID_CD: "44",
  },
  {
    SIG_KOR_NM: "태안군",
    SIG_CD: "44825",
    LON: 126.28095649258,
    LAT: 36.7036575458871,
    LX: 125.540787997642,
    LY: 36.3958140064875,
    RX: 126.434890200114,
    RY: 36.9779688564881,
    SID_CD: "44",
  },
  {
    SIG_KOR_NM: "홍성군",
    SIG_CD: "44800",
    LON: 126.625856252956,
    LAT: 36.5700941147415,
    LX: 126.426190510193,
    LY: 36.4597337706397,
    RX: 126.773191313368,
    RY: 36.6730209440247,
    SID_CD: "44",
  },
  {
    SIG_KOR_NM: "고창군",
    SIG_CD: "45790",
    LON: 126.616048492126,
    LAT: 35.4481682429918,
    LX: 126.426712085606,
    LY: 35.3007869794765,
    RX: 126.774175507955,
    RY: 35.574822090367,
    SID_CD: "45",
  },
  {
    SIG_KOR_NM: "군산시",
    SIG_CD: "45130",
    LON: 126.729175341281,
    LAT: 35.9512672331773,
    LX: 125.966846696854,
    LY: 35.6703582916067,
    RX: 126.915401954234,
    RY: 36.1278333063017,
    SID_CD: "45",
  },
  {
    SIG_KOR_NM: "김제시",
    SIG_CD: "45210",
    LON: 126.896163657503,
    LAT: 35.8068491704409,
    LX: 126.653715500586,
    LY: 35.6661431282391,
    RX: 127.086678759163,
    RY: 35.9177112531368,
    SID_CD: "45",
  },
  {
    SIG_KOR_NM: "남원시",
    SIG_CD: "45190",
    LON: 127.441890101471,
    LAT: 35.4225449399458,
    LX: 127.183907054515,
    LY: 35.3024577023864,
    RX: 127.674069338122,
    RY: 35.5608208530823,
    SID_CD: "45",
  },
  {
    SIG_KOR_NM: "무주군",
    SIG_CD: "45730",
    LON: 127.712952310346,
    LAT: 35.9393673357671,
    LX: 127.524368579075,
    LY: 35.7882309277078,
    RX: 127.911367379918,
    RY: 36.0686671281365,
    SID_CD: "45",
  },
  {
    SIG_KOR_NM: "부안군",
    SIG_CD: "45800",
    LON: 126.644653358604,
    LAT: 35.6779101008173,
    LX: 126.101575755351,
    LY: 35.5583288824263,
    RX: 126.841129365614,
    RY: 35.8128695748964,
    SID_CD: "45",
  },
  {
    SIG_KOR_NM: "순창군",
    SIG_CD: "45770",
    LON: 127.090088977313,
    LAT: 35.433633829368,
    LX: 126.859739160166,
    LY: 35.2992325980666,
    RX: 127.314269917024,
    RY: 35.5561268542249,
    SID_CD: "45",
  },
  {
    SIG_KOR_NM: "완주군",
    SIG_CD: "45710",
    LON: 127.215114992187,
    LAT: 35.9186151015155,
    LX: 126.995153679625,
    LY: 35.6188871407217,
    RX: 127.378228866303,
    RY: 36.1308408875847,
    SID_CD: "45",
  },
  {
    SIG_KOR_NM: "익산시",
    SIG_CD: "45140",
    LON: 126.98951085251,
    LAT: 36.0231054495757,
    LX: 126.851407473103,
    LY: 35.883493803356,
    RX: 127.139722011988,
    RY: 36.1565704339661,
    SID_CD: "45",
  },
  {
    SIG_KOR_NM: "임실군",
    SIG_CD: "45750",
    LON: 127.23664774532,
    LAT: 35.5982021259281,
    LX: 127.083093631987,
    LY: 35.4597105097544,
    RX: 127.43609982446,
    RY: 35.7776781648062,
    SID_CD: "45",
  },
  {
    SIG_KOR_NM: "장수군",
    SIG_CD: "45740",
    LON: 127.544264036969,
    LAT: 35.6574608866378,
    LX: 127.361811886527,
    LY: 35.4678138909932,
    RX: 127.699809388444,
    RY: 35.8389432636505,
    SID_CD: "45",
  },
  {
    SIG_KOR_NM: "전주시덕진구",
    SIG_CD: "45113",
    LON: 127.11291624378,
    LAT: 35.8587009871962,
    LX: 126.997843497868,
    LY: 35.8016511652763,
    RX: 127.234289375204,
    RY: 35.9031075132947,
    SID_CD: "45",
  },
  {
    SIG_KOR_NM: "전주시완산구",
    SIG_CD: "45111",
    LON: 127.119503887306,
    LAT: 35.7920943129566,
    LX: 127.050417737835,
    LY: 35.7285739873943,
    RX: 127.217020044743,
    RY: 35.843318843939,
    SID_CD: "45",
  },
  {
    SIG_KOR_NM: "정읍시",
    SIG_CD: "45180",
    LON: 126.905859939488,
    LAT: 35.6026248359353,
    LX: 126.715523433028,
    LY: 35.4610852020155,
    RX: 127.116936856832,
    RY: 35.7589911433904,
    SID_CD: "45",
  },
  {
    SIG_KOR_NM: "진안군",
    SIG_CD: "45720",
    LON: 127.430035517785,
    LAT: 35.8288075074163,
    LX: 127.265297446781,
    LY: 35.6186961707874,
    RX: 127.6248396474,
    RY: 36.0294951269083,
    SID_CD: "45",
  },
  {
    SIG_KOR_NM: "강진군",
    SIG_CD: "46810",
    LON: 126.772151930595,
    LAT: 34.6204647988006,
    LX: 126.656481255494,
    LY: 34.4465758946277,
    RX: 126.885848619405,
    RY: 34.7864423762498,
    SID_CD: "46",
  },
  {
    SIG_KOR_NM: "고흥군",
    SIG_CD: "46770",
    LON: 127.318597102109,
    LAT: 34.5977828517165,
    LX: 127.082196639419,
    LY: 34.3174313944187,
    RX: 127.545625585045,
    RY: 34.8277444883248,
    SID_CD: "46",
  },
  {
    SIG_KOR_NM: "곡성군",
    SIG_CD: "46720",
    LON: 127.263583181167,
    LAT: 35.2166132934254,
    LX: 127.081232508201,
    LY: 35.0693623973882,
    RX: 127.412280285793,
    RY: 35.3369492378863,
    SID_CD: "46",
  },
  {
    SIG_KOR_NM: "광양시",
    SIG_CD: "46230",
    LON: 127.655073295684,
    LAT: 35.0219785918918,
    LX: 127.525504531201,
    LY: 34.8865819017748,
    RX: 127.786823116328,
    RY: 35.1826945979176,
    SID_CD: "46",
  },
  {
    SIG_KOR_NM: "구례군",
    SIG_CD: "46730",
    LON: 127.503119253771,
    LAT: 35.2367662081963,
    LX: 127.366887020722,
    LY: 35.0946931651714,
    RX: 127.624624701395,
    RY: 35.3653356321481,
    SID_CD: "46",
  },
  {
    SIG_KOR_NM: "나주시",
    SIG_CD: "46170",
    LON: 126.720413543968,
    LAT: 34.9885894979602,
    LX: 126.513309649829,
    LY: 34.8679383375187,
    RX: 126.899200472562,
    RY: 35.1148553323442,
    SID_CD: "46",
  },
  {
    SIG_KOR_NM: "담양군",
    SIG_CD: "46710",
    LON: 126.995291287771,
    LAT: 35.291494743375,
    LX: 126.854199575894,
    LY: 35.1159544693554,
    RX: 127.117998077658,
    RY: 35.4665718501714,
    SID_CD: "46",
  },
  {
    SIG_KOR_NM: "목포시",
    SIG_CD: "46110",
    LON: 126.391782223506,
    LAT: 34.8039767968583,
    LX: 126.289708303494,
    LY: 34.7452624814654,
    RX: 126.459439337691,
    RY: 34.8444042407551,
    SID_CD: "46",
  },
  {
    SIG_KOR_NM: "무안군",
    SIG_CD: "46840",
    LON: 126.426003038052,
    LAT: 34.9530962252345,
    LX: 126.242243290845,
    LY: 34.7684721428804,
    RX: 126.556998203843,
    RY: 35.1668088569091,
    SID_CD: "46",
  },
  {
    SIG_KOR_NM: "보성군",
    SIG_CD: "46780",
    LON: 127.162122637423,
    LAT: 34.8143754769213,
    LX: 126.971844289699,
    LY: 34.6349658347296,
    RX: 127.480805986021,
    RY: 34.9875291475098,
    SID_CD: "46",
  },
  {
    SIG_KOR_NM: "순천시",
    SIG_CD: "46150",
    LON: 127.389163285323,
    LAT: 34.9947449986337,
    LX: 127.174843374773,
    LY: 34.8260895703244,
    RX: 127.593696598591,
    RY: 35.1891187326927,
    SID_CD: "46",
  },
  {
    SIG_KOR_NM: "신안군",
    SIG_CD: "46910",
    LON: 126.048933511626,
    LAT: 34.8124277587329,
    LX: 125.077726635088,
    LY: 34.0477108348723,
    RX: 126.378895056888,
    RY: 35.2127004350433,
    SID_CD: "46",
  },
  {
    SIG_KOR_NM: "여수시",
    SIG_CD: "46130",
    LON: 127.653203142038,
    LAT: 34.6961705320107,
    LX: 127.219304269574,
    LY: 34.004803815605,
    RX: 127.905626549969,
    RY: 34.8990969217737,
    SID_CD: "46",
  },
  {
    SIG_KOR_NM: "영광군",
    SIG_CD: "46870",
    LON: 126.453133317446,
    LAT: 35.278486074542,
    LX: 125.986121265043,
    LY: 35.163841886066,
    RX: 126.644798797075,
    RY: 35.4299825546782,
    SID_CD: "46",
  },
  {
    SIG_KOR_NM: "영암군",
    SIG_CD: "46830",
    LON: 126.630698359025,
    LAT: 34.7995683540509,
    LX: 126.362504571249,
    LY: 34.665088462972,
    RX: 126.859289844827,
    RY: 34.946344579203,
    SID_CD: "46",
  },
  {
    SIG_KOR_NM: "완도군",
    SIG_CD: "46890",
    LON: 126.776815001071,
    LAT: 34.295582305129,
    LX: 126.380411219839,
    LY: 33.9685728559491,
    RX: 127.201240375624,
    RY: 34.4607381282177,
    SID_CD: "46",
  },
  {
    SIG_KOR_NM: "장성군",
    SIG_CD: "46880",
    LON: 126.768496633449,
    LAT: 35.3295657289481,
    LX: 126.583316907437,
    LY: 35.1907181097442,
    RX: 126.926527707254,
    RY: 35.4869138251189,
    SID_CD: "46",
  },
  {
    SIG_KOR_NM: "장흥군",
    SIG_CD: "46800",
    LON: 126.921531937514,
    LAT: 34.6765368853465,
    LX: 126.792934409972,
    LY: 34.421982835583,
    RX: 127.04621061598,
    RY: 34.8778269339023,
    SID_CD: "46",
  },
  {
    SIG_KOR_NM: "진도군",
    SIG_CD: "46900",
    LON: 126.21506340022,
    LAT: 34.4394004129858,
    LX: 125.800637126291,
    LY: 34.1407189728521,
    RX: 126.385300015531,
    RY: 34.5929139886465,
    SID_CD: "46",
  },
  {
    SIG_KOR_NM: "함평군",
    SIG_CD: "46860",
    LON: 126.53560560607,
    LAT: 35.1126706597184,
    LX: 126.37036985522,
    LY: 34.9735097074731,
    RX: 126.672119097422,
    RY: 35.2355822265055,
    SID_CD: "46",
  },
  {
    SIG_KOR_NM: "해남군",
    SIG_CD: "46820",
    LON: 126.521795177877,
    LAT: 34.5458215088421,
    LX: 126.239903656055,
    LY: 34.2929116182599,
    RX: 126.734863955771,
    RY: 34.7621148402396,
    SID_CD: "46",
  },
  {
    SIG_KOR_NM: "화순군",
    SIG_CD: "46790",
    LON: 127.033434756253,
    LAT: 35.0081869697882,
    LX: 126.823877710496,
    LY: 34.8236977355776,
    RX: 127.201633526851,
    RY: 35.2142940068041,
    SID_CD: "46",
  },
  {
    SIG_KOR_NM: "경산시",
    SIG_CD: "47290",
    LON: 128.80905363373,
    LAT: 35.8340601550012,
    LX: 128.681396760536,
    LY: 35.7005008981474,
    RX: 128.970948479407,
    RY: 35.9939228851345,
    SID_CD: "47",
  },
  {
    SIG_KOR_NM: "경주시",
    SIG_CD: "47130",
    LON: 129.235917479977,
    LAT: 35.8266450249172,
    LX: 128.970726778826,
    LY: 35.6403558889322,
    RX: 129.52020828655,
    RY: 36.0796971607524,
    SID_CD: "47",
  },
  {
    SIG_KOR_NM: "고령군",
    SIG_CD: "47830",
    LON: 128.306731750261,
    LAT: 35.7371966020093,
    LX: 128.159328482346,
    LY: 35.6108809425219,
    RX: 128.48306896007,
    RY: 35.8524061805704,
    SID_CD: "47",
  },
  {
    SIG_KOR_NM: "구미시",
    SIG_CD: "47190",
    LON: 128.355552627604,
    LAT: 36.2073114373463,
    LX: 128.132779896532,
    LY: 36.0605811718771,
    RX: 128.564002887628,
    RY: 36.3624668303222,
    SID_CD: "47",
  },
  {
    SIG_KOR_NM: "군위군",
    SIG_CD: "47720",
    LON: 128.648217757849,
    LAT: 36.1701146745195,
    LX: 128.410439113246,
    LY: 36.0073067819145,
    RX: 128.9001966589,
    RY: 36.3272364578906,
    SID_CD: "47",
  },
  {
    SIG_KOR_NM: "김천시",
    SIG_CD: "47150",
    LON: 128.077705628235,
    LAT: 36.0604219047678,
    LX: 127.875271003904,
    LY: 35.8289340176238,
    RX: 128.301234448647,
    RY: 36.2583411995821,
    SID_CD: "47",
  },
  {
    SIG_KOR_NM: "문경시",
    SIG_CD: "47280",
    LON: 128.148604381477,
    LAT: 36.6907902024808,
    LX: 127.874292892355,
    LY: 36.513023188774,
    RX: 128.372048643854,
    RY: 36.8723286730651,
    SID_CD: "47",
  },
  {
    SIG_KOR_NM: "봉화군",
    SIG_CD: "47920",
    LON: 128.912890720277,
    LAT: 36.9341393225951,
    LX: 128.637520869061,
    LY: 36.7464881488149,
    RX: 129.185462041993,
    RY: 37.1004020085045,
    SID_CD: "47",
  },
  {
    SIG_KOR_NM: "상주시",
    SIG_CD: "47250",
    LON: 128.067003380241,
    LAT: 36.429502501989,
    LX: 127.796152132029,
    LY: 36.2371635581892,
    RX: 128.339037088318,
    RY: 36.6567672478367,
    SID_CD: "47",
  },
  {
    SIG_KOR_NM: "성주군",
    SIG_CD: "47840",
    LON: 128.233391032508,
    LAT: 35.9072234162336,
    LX: 128.04665086672,
    LY: 35.7771922384033,
    RX: 128.39913478932,
    RY: 36.0553953921266,
    SID_CD: "47",
  },
  {
    SIG_KOR_NM: "안동시",
    SIG_CD: "47170",
    LON: 128.780033196698,
    LAT: 36.5802421413176,
    LX: 128.428488892546,
    LY: 36.2957235069005,
    RX: 129.001598417613,
    RY: 36.8231625871392,
    SID_CD: "47",
  },
  {
    SIG_KOR_NM: "영덕군",
    SIG_CD: "47770",
    LON: 129.317375389675,
    LAT: 36.482387618959,
    LX: 129.147708077586,
    LY: 36.2665560616649,
    RX: 129.452904291817,
    RY: 36.6738716178529,
    SID_CD: "47",
  },
  {
    SIG_KOR_NM: "영양군",
    SIG_CD: "47760",
    LON: 129.145028012452,
    LAT: 36.6963878683716,
    LX: 128.983780404296,
    LY: 36.4889209436212,
    RX: 129.31411621283,
    RY: 36.8815470249953,
    SID_CD: "47",
  },
  {
    SIG_KOR_NM: "영주시",
    SIG_CD: "47210",
    LON: 128.597681190868,
    LAT: 36.8704761800922,
    LX: 128.423969748786,
    LY: 36.6953703290397,
    RX: 128.745569321393,
    RY: 37.0657143627314,
    SID_CD: "47",
  },
  {
    SIG_KOR_NM: "영천시",
    SIG_CD: "47230",
    LON: 128.942618202791,
    LAT: 36.015778849296,
    LX: 128.694159426823,
    LY: 35.8300898118959,
    RX: 129.151327275395,
    RY: 36.1845934442037,
    SID_CD: "47",
  },
  {
    SIG_KOR_NM: "예천군",
    SIG_CD: "47900",
    LON: 128.422382222963,
    LAT: 36.6538435477899,
    LX: 128.260644575886,
    LY: 36.4543511205551,
    RX: 128.610520523294,
    RY: 36.848606461797,
    SID_CD: "47",
  },
  {
    SIG_KOR_NM: "울릉군",
    SIG_CD: "47940",
    LON: 130.862918323401,
    LAT: 37.506005897232,
    LX: 130.791486737455,
    LY: 37.2378890962413,
    RX: 131.872862189363,
    RY: 37.5532188822434,
    SID_CD: "47",
  },
  {
    SIG_KOR_NM: "울진군",
    SIG_CD: "47930",
    LON: 129.3123160786,
    LAT: 36.9039180832996,
    LX: 129.077196495753,
    LY: 36.6435311571418,
    RX: 129.47870463038,
    RY: 37.1468296867986,
    SID_CD: "47",
  },
  {
    SIG_KOR_NM: "의성군",
    SIG_CD: "47730",
    LON: 128.615054085453,
    LAT: 36.3620483306153,
    LX: 128.287682202456,
    LY: 36.1907132180017,
    RX: 128.896620815188,
    RY: 36.5325915520518,
    SID_CD: "47",
  },
  {
    SIG_KOR_NM: "청도군",
    SIG_CD: "47820",
    LON: 128.786514914578,
    LAT: 35.6729729063405,
    LX: 128.526808447095,
    LY: 35.5668881614374,
    RX: 129.04690108057,
    RY: 35.8459480367385,
    SID_CD: "47",
  },
  {
    SIG_KOR_NM: "청송군",
    SIG_CD: "47750",
    LON: 129.057381909986,
    LAT: 36.3569747721701,
    LX: 128.846888344047,
    LY: 36.1606265425952,
    RX: 129.254209126493,
    RY: 36.5949630501784,
    SID_CD: "47",
  },
  {
    SIG_KOR_NM: "칠곡군",
    SIG_CD: "47850",
    LON: 128.462580815789,
    LAT: 36.0155111631099,
    LX: 128.284957065395,
    LY: 35.8864481180985,
    RX: 128.640720400989,
    RY: 36.1258986364402,
    SID_CD: "47",
  },
  {
    SIG_KOR_NM: "포항시 남구",
    SIG_CD: "47111",
    LON: 129.437649786038,
    LAT: 35.958135160174,
    LX: 129.276815894661,
    LY: 35.8383389487449,
    RX: 129.584683970194,
    RY: 36.0858620811233,
    SID_CD: "47",
  },
  {
    SIG_KOR_NM: "포항시 북구",
    SIG_CD: "47113",
    LON: 129.233702690982,
    LAT: 36.1651636440021,
    LX: 128.989490786857,
    LY: 36.0141518102253,
    RX: 129.455186410311,
    RY: 36.3333652414194,
    SID_CD: "47",
  },
  {
    SIG_KOR_NM: "거제시",
    SIG_CD: "48310",
    LON: 128.623138155677,
    LAT: 34.870434544831,
    LX: 128.45528475152,
    LY: 34.6696528568967,
    RX: 128.776214744243,
    RY: 35.0407985531781,
    SID_CD: "48",
  },
  {
    SIG_KOR_NM: "거창군",
    SIG_CD: "48880",
    LON: 127.904168552298,
    LAT: 35.7325525378176,
    LX: 127.679436262258,
    LY: 35.5143956971216,
    RX: 128.095184260548,
    RY: 35.9099440599802,
    SID_CD: "48",
  },
  {
    SIG_KOR_NM: "고성군",
    SIG_CD: "48820",
    LON: 128.290475438992,
    LAT: 35.0163611127418,
    LX: 128.10118039031,
    LY: 34.87876171564,
    RX: 128.501494219728,
    RY: 35.1324378867052,
    SID_CD: "48",
  },
  {
    SIG_KOR_NM: "김해시",
    SIG_CD: "48250",
    LON: 128.845212720681,
    LAT: 35.2721560170124,
    LX: 128.691578851941,
    LY: 35.1504648573935,
    RX: 129.014817821686,
    RY: 35.3955491658549,
    SID_CD: "48",
  },
  {
    SIG_KOR_NM: "남해군",
    SIG_CD: "48840",
    LON: 127.941105424528,
    LAT: 34.8183269876303,
    LX: 127.807011028927,
    LY: 34.5020077022697,
    RX: 128.113329902775,
    RY: 34.9469744588622,
    SID_CD: "48",
  },
  {
    SIG_KOR_NM: "밀양시",
    SIG_CD: "48270",
    LON: 128.789594340078,
    LAT: 35.4984981300514,
    LX: 128.571166678695,
    LY: 35.345506951618,
    RX: 129.024622857672,
    RY: 35.6406187446706,
    SID_CD: "48",
  },
  {
    SIG_KOR_NM: "사천시",
    SIG_CD: "48240",
    LON: 128.037670820946,
    LAT: 35.0497939985887,
    LX: 127.878964731949,
    LY: 34.8869402274315,
    RX: 128.184352250719,
    RY: 35.1593505601578,
    SID_CD: "48",
  },
  {
    SIG_KOR_NM: "산청군",
    SIG_CD: "48860",
    LON: 127.884336747802,
    LAT: 35.368597155505,
    LX: 127.687911449262,
    LY: 35.2190310455405,
    RX: 128.115199139031,
    RY: 35.5762105944654,
    SID_CD: "48",
  },
  {
    SIG_KOR_NM: "양산시",
    SIG_CD: "48330",
    LON: 129.041038016494,
    LAT: 35.4018882953729,
    LX: 128.874072832355,
    LY: 35.2737586097437,
    RX: 129.219071994511,
    RY: 35.5322675261251,
    SID_CD: "48",
  },
  {
    SIG_KOR_NM: "의령군",
    SIG_CD: "48720",
    LON: 128.277056127239,
    LAT: 35.3924301575146,
    LX: 128.082579523918,
    LY: 35.2533663230391,
    RX: 128.437447333966,
    RY: 35.5173837521136,
    SID_CD: "48",
  },
  {
    SIG_KOR_NM: "진주시",
    SIG_CD: "48170",
    LON: 128.129797508102,
    LAT: 35.2051581985463,
    LX: 127.887817727363,
    LY: 35.0509238406439,
    RX: 128.368200386778,
    RY: 35.3511280475899,
    SID_CD: "48",
  },
  {
    SIG_KOR_NM: "창녕군",
    SIG_CD: "48740",
    LON: 128.493050454748,
    LAT: 35.5082287490527,
    LX: 128.350443537746,
    LY: 35.3685672851332,
    RX: 128.651639303527,
    RY: 35.6831551143632,
    SID_CD: "48",
  },
  {
    SIG_KOR_NM: "창원시 마산합포구",
    SIG_CD: "48125",
    LON: 128.485253371172,
    LAT: 35.1354582978404,
    LX: 128.348136384998,
    LY: 35.0521809424429,
    RX: 128.639862259875,
    RY: 35.2225090800142,
    SID_CD: "48",
  },
  {
    SIG_KOR_NM: "창원시 마산회원구",
    SIG_CD: "48127",
    LON: 128.536432534514,
    LAT: 35.2322264699803,
    LX: 128.473659683622,
    LY: 35.1770851022722,
    RX: 128.62693719887,
    RY: 35.2770771550657,
    SID_CD: "48",
  },
  {
    SIG_KOR_NM: "창원시 성산구",
    SIG_CD: "48123",
    LON: 128.672103381215,
    LAT: 35.1961856278265,
    LX: 128.589258503181,
    LY: 35.1509157612725,
    RX: 128.751393814752,
    RY: 35.2459974206182,
    SID_CD: "48",
  },
  {
    SIG_KOR_NM: "창원시 의창구",
    SIG_CD: "48121",
    LON: 128.649587574649,
    LAT: 35.3089490503945,
    LX: 128.559292363666,
    LY: 35.2171111878394,
    RX: 128.76411656366,
    RY: 35.3933776228416,
    SID_CD: "48",
  },
  {
    SIG_KOR_NM: "창원시 진해구",
    SIG_CD: "48129",
    LON: 128.736298975284,
    LAT: 35.1299500203266,
    LX: 128.606716221317,
    LY: 35.0558842446136,
    RX: 128.843270262221,
    RY: 35.1811733124849,
    SID_CD: "48",
  },
  {
    SIG_KOR_NM: "통영시",
    SIG_CD: "48220",
    LON: 128.374075124097,
    LAT: 34.8293276134332,
    LX: 128.125587372901,
    LY: 34.5335102558231,
    RX: 128.736063628293,
    RY: 34.9763799886094,
    SID_CD: "48",
  },
  {
    SIG_KOR_NM: "하동군",
    SIG_CD: "48850",
    LON: 127.779048346918,
    LAT: 35.1383054607931,
    LX: 127.576070744231,
    LY: 34.9240198464766,
    RX: 127.939253895536,
    RY: 35.332562723665,
    SID_CD: "48",
  },
  {
    SIG_KOR_NM: "함안군",
    SIG_CD: "48730",
    LON: 128.43087470433,
    LAT: 35.2910020947218,
    LX: 128.274041805585,
    LY: 35.1640128250803,
    RX: 128.591650215348,
    RY: 35.4015134623303,
    SID_CD: "48",
  },
  {
    SIG_KOR_NM: "함양군",
    SIG_CD: "48870",
    LON: 127.722040980417,
    LAT: 35.5516015422983,
    LX: 127.584861174213,
    LY: 35.3157553179924,
    RX: 127.877923827429,
    RY: 35.7713736640451,
    SID_CD: "48",
  },
  {
    SIG_KOR_NM: "합천군",
    SIG_CD: "48890",
    LON: 128.141541760283,
    LAT: 35.5765773141855,
    LX: 127.953228557491,
    LY: 35.3679032091397,
    RX: 128.379855171528,
    RY: 35.8322740845382,
    SID_CD: "48",
  },
  {
    SIG_KOR_NM: "서귀포시",
    SIG_CD: "50130",
    LON: 126.581103974799,
    LAT: 33.3250450883096,
    LX: 126.168750175037,
    LY: 33.1137120723933,
    RX: 126.945459238823,
    RY: 33.4830810721477,
    SID_CD: "50",
  },
  {
    SIG_KOR_NM: "제주시",
    SIG_CD: "50110",
    LON: 126.529265802687,
    LAT: 33.4422078876389,
    LX: 126.144115836633,
    LY: 33.2729641821409,
    RX: 126.970427989344,
    RY: 34.0153032271961,
    SID_CD: "50",
  },
];

// Tap Index

// 맵 상단 버튼
const TI_NORMAL_MAP_BUTTON = 3010; // 일반지도
const TI_SATELITE_MAP_BUTTON = 3020; // 위성지도
const TI_SHOW_CHART_BUTTON = 3030; // 차트보기
const TI_SHOW_LIST_BUTTON = 3040; // 목록 보기

const TI_LIST_EXCEL_BUTTON = 3050;
const TI_LIST_CLOSE_BUTTON = 3060;

const TI_WIDGET_CONTAINER_CLOSE_BUTTON = 4098;
const TI_WIDGET_CONTAINER_OPEN_BUTTON = 4099;

// gis/radiomap.do?menuNo=40101
// 지역별 주파수 찾기 > 방송사 채널 선택
const TI_BROD_CH_COMBO_BOX = 4001;
const TI_BROD_CH_COMBO_BOX_DETAIL = 4002;
const TI_HIGHWAY_COMBO_BOX = 4003;
const TI_RAW_EXCEL_DOWN_BUTTON = 4004;
const TI_TABLE_EXCEL_DOWN_BUTTON = 4005;

// 지역별 주파수 찾기 > 고속도로 경로 탐색
const TI_HIGHWAY_PATH_MODAL_CLOSE_BUTTON = 4100;

// 맵 아이콘
const TI_MAP_CLUSTER_BUTTON = 5001;
const TI_MAP_LAYER_BUTTON = 5002;
const TI_MAP_CURRENT_LOCATION_BUTTON = 5003;
const TI_MAP_PLUS_BUTTON = 5004;
const TI_MAP_MINUS_BUTTON = 5005;
const TI_MAP_RULER_BUTTON = 5006;
const TI_MAP_PRINT_BUTTON = 5007;

// gis/wavemap.do
// 무선국정보 > 일반무선국 > 일반무선국 찾기
const TI_FIND_LOCATION_INPUT = 4001; // 공통 컴포넌트 주의하기
const TI_ADDRESS_SEARCH_BUTTON = 4002;
const TI_NAME_SEARCH_BUTTON = 4003;
const TI_SELECT_ALL_CHECK_BOX = 4050;
// const TI_SELECT_KO_JUNG_CHECK_BOX = 4005;
// const TI_SELECT_KI_JI_CHECK_BOX = 4006;
// const TI_SELECT_MOVEMENT_CHECK_BOX = 4007;
// const TI_SELECT_AMATEUR_CHECK_BOX = 4008;
const TI_SEARCH_RADIUS_500 = 4071; // 공통 컴포넌트 주의하기
const TI_SEARCH_RADIUS_1000 = 4072; // 공통 컴포넌트 주의하기

const TI_WIDGET_TABLE = 5000; // 공통 컴포넌트 주의하기

// rwdinfolabstats/viewYearByClsByFyerCmpr.do?menuNo=50203
// 무선국 종합 정보

const TI_CHART_BUTTON = 3001;
const TI_CRITERIA_YEAR = 4001;
const TI_CRITERIA_MONTH = 4002;
const TI_COMPARE_YEAR = 4003;
const TI_COMPARE_MONTH = 4004;
const TI_SEARCH_BUTTON = 4005;
const TI_COMPARE_MODAL_CLOSE_BUTTON = 3001;
const TI_CENTER_BUTTON = 4100;

const TI_MODAL_RESULT_CLOSE_BUTTON = 6001;
const TI_SELECT_KUK_JONG = 6002;

// gis/waveworkmap_service.do
// 일자리 맵
const TI_SELECT_SIGUNGOO_INPUT = 4001;
const TI_SELECT_SIGUNGOO_RESET_BUTTON = 4002;
const TI_SELECT_ALL_JOB = 4003;

// gis/mobile_service.do
// 이동통신 무선국 찾기
const TI_SEARCH_ADDRESS_TAB_BUTTON = 3999;
const TI_SEARCH_PERMIT_NUMBER_TAB_BUTTON = 4000;
// const TI_SEARCH_LOCATION_INPUT = 4003;
const TI_SEARCH_ADDRESS_TAP_ADDRESS_BUTTON = 4004;
const TI_SEARCH_ADDRESS_TAP_NAME_BUTTON = 4004;
const TI_3G_CHECK_BOX = 4005;
const TI_4G_CHECK_BOX = 4006;
const TI_5G_CHECK_BOX = 4007;
const TI_500_RADIUS_BUTTON = 4008;
const TI_1000_RADIUS_BUTTON = 4009;
const TI_SEARCH_PERMIT_NUMBER_REGULAR_BUTTON = 4010;
const TI_SEARCH_PERMIT_NUMBER_ING_BUTTON = 4010;
const TI_SEARCH_PERMIT_INPUT = 4011;
const TI_SEARCH_PERMIT_SEARCH_BUTTON = 4012;

//gis/nationalpark_service.do
//산악지역 이동통신 찾기
const TI_SELECT_NATIONAL_PARK_BUTTON = 4001;
const TI_SELECT_DORIP_PARK_BUTTON = 4002;
const TI_SELECT_GUNRIP_PARK_BUTTON = 4003;
const TI_SELECT_PARK_COMBO_BOX = 4004;
const TI_HIDE_CARRIER_CHECK_BOX = 4005;
const TI_EXTEND_BOUNDARY_CHECK_BOX = 4006;
const TI_ALL_CARRIER_BUTTON = 4007;
const TI_SKT_CARRIER_BUTTON = 4008;
const TI_KT_CARRIER_BUTTON = 4009;
const TI_LGT_CARRIER_BUTTON = 4010;
const TI_ALL_SERVICE_RECEPTION_BUTTON = 4011;
const TI_3G_SERVICE_RECEPTION_BUTTON = 4012;
const TI_4G_SERVICE_RECEPTION_BUTTON = 4013;
const TI_5G_SERVICE_RECEPTION_BUTTON = 4014;
const TI_3G_RECEPTION_CHECK_BOX = 4015;
const TI_4G_RECEPTION_CHECK_BOX = 4016;
const TI_RECEPTION_HEATMAP_SWITCH = 4017;
const TI_ADDITIONAL_INFO = 4018;

// rwdinfolabstats/viewYearByClsByStats.do
// 무선국 현황
const TI_YEAR_DETAIL_SWITCH = 4001;
const TI_FROM_YEAR_COMBO = 4002;
const TI_FROM_MONTH_COMBO = 4003;
const TI_TO_YEAR_COMBO = 4004;
const TI_TO_MONTH_COMBO = 4005;
const TI_WIFI_TYPE_CHECK_ALL = 4006;

// viewRdwAnalsStatsData1
// 전파자원 분석
const TI_SELECT_YEAR_COMBO = 4010;

export {
  TI_SELECT_YEAR_COMBO,
  TI_YEAR_DETAIL_SWITCH,
  TI_FROM_YEAR_COMBO,
  TI_FROM_MONTH_COMBO,
  TI_TO_YEAR_COMBO,
  TI_TO_MONTH_COMBO,
  TI_WIFI_TYPE_CHECK_ALL,
  TI_ALL_SERVICE_RECEPTION_BUTTON,
  TI_3G_SERVICE_RECEPTION_BUTTON,
  TI_4G_SERVICE_RECEPTION_BUTTON,
  TI_5G_SERVICE_RECEPTION_BUTTON,
  TI_SELECT_NATIONAL_PARK_BUTTON,
  TI_SELECT_DORIP_PARK_BUTTON,
  TI_SELECT_GUNRIP_PARK_BUTTON,
  TI_SELECT_PARK_COMBO_BOX,
  TI_HIDE_CARRIER_CHECK_BOX,
  TI_EXTEND_BOUNDARY_CHECK_BOX,
  TI_ALL_CARRIER_BUTTON,
  TI_SKT_CARRIER_BUTTON,
  TI_KT_CARRIER_BUTTON,
  TI_LGT_CARRIER_BUTTON,
  TI_3G_RECEPTION_CHECK_BOX,
  TI_4G_RECEPTION_CHECK_BOX,
  TI_RECEPTION_HEATMAP_SWITCH,
  TI_ADDITIONAL_INFO,
  TI_SHOW_CHART_BUTTON,
  TI_SEARCH_ADDRESS_TAB_BUTTON,
  TI_SEARCH_PERMIT_NUMBER_TAB_BUTTON,
  TI_SEARCH_ADDRESS_TAP_ADDRESS_BUTTON,
  TI_SEARCH_ADDRESS_TAP_NAME_BUTTON,
  TI_3G_CHECK_BOX,
  TI_4G_CHECK_BOX,
  TI_5G_CHECK_BOX,
  TI_500_RADIUS_BUTTON,
  TI_1000_RADIUS_BUTTON,
  TI_SEARCH_PERMIT_NUMBER_REGULAR_BUTTON,
  TI_SEARCH_PERMIT_NUMBER_ING_BUTTON,
  TI_SEARCH_PERMIT_INPUT,
  TI_SEARCH_PERMIT_SEARCH_BUTTON,
  TI_SELECT_SIGUNGOO_INPUT,
  TI_SELECT_SIGUNGOO_RESET_BUTTON,
  TI_SELECT_ALL_JOB,
  TI_MODAL_RESULT_CLOSE_BUTTON,
  TI_SELECT_KUK_JONG,
  TI_LIST_EXCEL_BUTTON,
  TI_LIST_CLOSE_BUTTON,
  TI_CENTER_BUTTON,
  TI_COMPARE_MODAL_CLOSE_BUTTON,
  TI_CHART_BUTTON,
  TI_CRITERIA_YEAR,
  TI_CRITERIA_MONTH,
  TI_COMPARE_YEAR,
  TI_COMPARE_MONTH,
  TI_SEARCH_BUTTON,
  TI_FIND_LOCATION_INPUT,
  TI_ADDRESS_SEARCH_BUTTON,
  TI_NAME_SEARCH_BUTTON,
  TI_SELECT_ALL_CHECK_BOX,
  TI_SEARCH_RADIUS_500,
  TI_SEARCH_RADIUS_1000,
  TI_NORMAL_MAP_BUTTON,
  TI_SATELITE_MAP_BUTTON,
  TI_SHOW_LIST_BUTTON,
  TI_BROD_CH_COMBO_BOX,
  TI_BROD_CH_COMBO_BOX_DETAIL,
  TI_HIGHWAY_COMBO_BOX,
  TI_RAW_EXCEL_DOWN_BUTTON,
  TI_TABLE_EXCEL_DOWN_BUTTON,
  TI_WIDGET_CONTAINER_CLOSE_BUTTON,
  TI_WIDGET_CONTAINER_OPEN_BUTTON,
  TI_HIGHWAY_PATH_MODAL_CLOSE_BUTTON,
  TI_MAP_CLUSTER_BUTTON,
  TI_MAP_LAYER_BUTTON,
  TI_MAP_CURRENT_LOCATION_BUTTON,
  TI_MAP_PLUS_BUTTON,
  TI_MAP_MINUS_BUTTON,
  TI_MAP_RULER_BUTTON,
  TI_MAP_PRINT_BUTTON,
  DEBUG,
  API_HOST,
  WELL_KNOWN_POSITION,
  INITIAL_MAP_TYPE,
  MAP_VENDOR,
  GOOGLE_LANGUAGE,
  GOOGLE_REGION,
  GOOGLE_MAPS_API_KEY,
  GOOGLE_MAPS_VERSION,
  GOOGLE_MAPS_REGION,
  // GOOGLE_MAPS_API_URL,
  KAKAO_MAPS_API_URL,
  MAPBOX_APIKEY,
  MAPBOX_STYLE,
  VWORLD_APIKEY,
  INITIAL_VIEW_STATE,
  INITIAL_GEOJSON_POLYGON_LAYER_PROPS,
  INITIAL_GEOJSON_POINT_LAYER_PROPS,
  INITIAL_POINT_LAYER_PROPS,
  INITIAL_LAYER_WMS_TYPES,
  USER_GBN,
  GEOSERVER_URL,
  SPECTRUM_BGN_FRQ_HZ,
  SPECTRUM_END_FRQ_HZ,
  SPECTRUM_FRQ_HZ,
  SPECTRUM_SIDO_CHECK_LIST,
  SPECTRUM_UCODE_CHECK_LIST,
  SPECTRUM_USAGE_CHECK_LIST,
  JSON_SIGUNGU,
  TI_WIDGET_TABLE,
};
